import { render } from "./resetUserPassword.vue?vue&type=template&id=62f0c75c&scoped=true"
import script from "./resetUserPassword.vue?vue&type=script&lang=js"
export * from "./resetUserPassword.vue?vue&type=script&lang=js"

import "./resetUserPassword.vue?vue&type=style&index=0&id=62f0c75c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f0c75c"]])

export default __exports__